import { useContext } from 'react';
import { IPauseDetails, defaultTimeZone } from 'generated/custom';
import { FirebaseContext } from 'fbase';
import moment from 'moment-timezone';
import RestaurantModel from 'models/Restaurant';
import { useObject } from 'react-firebase-hooks/database';

interface IProps {
  restaurant: RestaurantModel | null;
}

export default ({ restaurant }: IProps) => {
  const { firebase } = useContext(FirebaseContext);

  const [snapshot] = useObject(firebase?.getRealtimeDB().ref(`/orderPause/${restaurant?.getId}/`));

  const pauseData: IPauseDetails | null | undefined = snapshot?.val();

  const now = moment.tz(restaurant?.getTimezone || defaultTimeZone).format('YYYY-MM-DD');

  const diningPause = pauseData && pauseData.DINING ? pauseData.DINING?.status === 'pause' && now === pauseData.DINING?.pauseDate : false;

  const takeOutPause = pauseData && pauseData.TAKEOUT ? pauseData.TAKEOUT?.status === 'pause' && now === pauseData.TAKEOUT?.pauseDate : false;

  const deliveryPause = pauseData && pauseData.DELIVERY ? pauseData.DELIVERY?.status === 'pause' && now === pauseData.DELIVERY?.pauseDate : false;

  return {
    pauseData,
    diningPause,
    takeOutPause,
    deliveryPause
  };
};
